<template>
    <div>
        <card  class="cursor-pointer mb-2">
            <div class="p-3 text-center" @click="open">
                <img src="/img/zillow.png" style="max-height: 60px;" />
                <div class="small" v-if="integrated">
                    <strong class="mr-1">Screen Name:</strong>
                    {{ integration.zillow_review_screen_name }}
                </div>
            </div>
        </card>

        <modal ref="modal" :has-footer="false" @hide="close()">
            <h5 slot="title">
                Zillow Integration
            </h5>

            <div>                            
                <div class="alert alert-warning zillow__note" role="alert">
                    <p>
                        Ex: https://www.zillow.com/profile/<strong>profileScreenName</strong>/
                    <p>
                    <p>
                        or
                    </p>
                    <p>
                        Ex: https://www.zillow.com/lender-profile/<strong>profileScreenName</strong>/
                    </p>
                    <p>
                        Copy the <strong>bold</strong> part in the screen name field.
                    </p>
                </div>

                <div class="form-group">
                    <label>Screen Name</label>
                    <input-text
                        placeholder="Enter Screen Name"
                        v-model="form.zillow_name"
                        :form="form"
                        field="zillow_name"
                    />
                </div>

                <div class="modal-footer mt-2 pr-0 pb-0 pl-0">
                    <button type="button" class="btn btn-default" @click="closeEdit()">
                        Cancel
                    </button>
                    <button-loading type="button" class="btn btn-primary ml-2"
                        :loading="form.submitting"
                        @click="save">
                        Save
                    </button-loading>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
    export default {
        props: ['integration'],

        data() {
            return {
                form: new Form()
            }
        },

        computed: {
            integrated() {
                return !!this.integration && !!this.integration.zillow_review_screen_name;
            }
        },

        watch: {
            integration: {
                immediate: true,
                handler() {
                    if (this.integration && this.integration.id) {
                        this.form = new Form({
                            location_id: this.integration.id,
                            zillow_name: this.integration.zillow_review_screen_name
                        });
                        return;
                    }

                    this.form = new Form();
                }
            }
        },

        methods: {
            open() {
                this.$refs.modal.open();
                this.$emit('show', true);                
            },

            close() {                
                this.$emit('hide');
            },

            closeEdit() {
                this.$refs.modal.close();
            },

            save() {
                return this.form.put(this.$laroute.route('location-zillow-screen-name.update', {
                    location: this.form.location_id
                }))
                .then(({data}) => {                    
                    swal.fire({
                        title: 'Location Saved!',
                        type: 'success',
                    }).then(() => {
                        this.closeEdit();
                        this.$emit('save-integration', data.id);
                    });
                })
                .catch(error => console.error(error));
            }
        }
    }
</script>

<style lang="scss" scoped>
    .zillow__note {
        font-size: .8em;
    }
</style>
